import * as React from 'react';
// import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TabHeaderBlock from '../components/TabHeaderBlock';
import TabSidebarBlock from '../components/TabSidebarBlock';
import { WhiteBlock } from '../styles/WhiteBlock';

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div className="db-area-main">
      <div className="db-container">
        <a href="#!" className="db-back-link button-chevron-left">
          <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
          dashboard
        </a>

        <h1 className="db-heading">
          Dribbble Workspace{' '}
          <img
            src="/img/chevron-down.svg"
            alt="chevron"
            style={{ width: 23, opacity: 0.4 }}
          />
        </h1>

        <TabHeaderBlock />

        <div className="db-tab-content-block">
          <div className="flex-row">
            <div className="col sidebar-col">
              <TabSidebarBlock />
            </div>

            <div className="col right-block-col">
              <WhiteBlock>
                <h2 className="white-block-head">General SEO Settings</h2>

                <div className="white-block-body">
                  <div className="flex-row">
                    <div className="col col-6">
                      <div className="form-group">
                        <label>Author Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Author Name"
                        />
                      </div>
                    </div>
                    <div className="col col-6">
                      <div className="form-group">
                        <label>Publisher Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Publisher Name"
                        />
                      </div>
                    </div>
                    <div className="col col-6">
                      <div className="form-group">
                        <label>Author Type</label>
                        <select
                          className="form-control"
                          placeholder="Enter Publisher Name">
                          <option>Person</option>
                        </select>
                      </div>
                    </div>
                    <div className="col col-6">
                      <div className="form-group">
                        <label>Story Language</label>
                        <select
                          className="form-control"
                          placeholder="Enter Publisher Name">
                          <option>English</option>
                          <option>Hindi</option>
                          <option>Tamil</option>
                        </select>
                      </div>
                    </div>
                    <div className="col flex-1">
                      <div className="text-right">
                        <button className="button" type="submit">
                          Save Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </WhiteBlock>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default IndexPage;
